import { render, staticRenderFns } from "./MatchPrincipalAccordion.vue?vue&type=template&id=3efc4183&"
import script from "./MatchPrincipalAccordion.vue?vue&type=script&lang=ts&"
export * from "./MatchPrincipalAccordion.vue?vue&type=script&lang=ts&"
import style0 from "./MatchPrincipalAccordion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports